import { Dialog, DialogTitle, DialogContent, Box, Typography, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { useTranslation } from '../hooks/useTranslation';
import FanthonReact from 'fanthon-card';

const FANTHON_TOKEN = process.env.REACT_APP_FANTHON_TOKEN;

const PaymentCreditCardModal = ({ onClose, onSubmit }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={true} onClose={onClose} maxWidth="md" fullWidth>
      {/* Header */}
      <DialogTitle sx={{ borderBottom: '2px solid #DCDCDC', marginBottom: '12px' }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <CreditCardIcon sx={{ color: '#83d84d', width: '32px', height: '32px' }} />

            <Typography fontWeight={600} color="#939598">
              Cartão de crédito
            </Typography>
          </Box>
          <IconButton onClick={onClose} sx={{ color: '#2C2C2C' }}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent maxWidth="md">
        <FanthonReact
          token={FANTHON_TOKEN}
          options={{
            number: {
              showIcon: false,
            },
          }}
          onSubmit={onSubmit}
        />
      </DialogContent>
    </Dialog>
  );
};

export default PaymentCreditCardModal;
